import { styled } from "@mui/material/styles";

/**
 * The shared Checkbox centres its own row (`CheckboxContainer` uses
 * `justifyContent: center`), which reads as a stray sentence when it sits in a stack of
 * left-aligned modal copy. Nudge just this dialog's rows back to the text edge.
 */
export const CheckboxRow = styled("div")({
  "& > div": {
    justifyContent: "flex-start",
  },
});
